import JoinCta from '@/components/shared/JoinCTA';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import Image from 'next/image';
import styled from 'styled-components';
import { adjustContentVisibility, Section, SectionTitle, SectionParagraph as Subtitle } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';

const Title = styled(SectionTitle)`
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: initial;
  `}
`;

const StyledSubtitle = styled(Subtitle)`
  margin-top: 10px;
  margin-bottom: 40px;
`;

const DesktopImage = styled(Image)`
  display: none;
  pointer-events: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: block;

  `}
`;

const MobileImage = styled(Image)`
  display: block;
  pointer-events: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: none;

  `}
`;

const StyledLink = styled(JoinCta)`
  display: block;
  margin-top: 40px;
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export interface SwitchingProps extends DefaultSectionProps {
  readonly title: string;
  readonly subtitle: string;
  readonly cta: { readonly ctaUrl: string; readonly ctaLabel: string };
  readonly compMobileImgUrl: StaticImageData;
  readonly compDesktopImgUrl: StaticImageData;
  readonly showDivider?: boolean;
  readonly darkBackground?: boolean;
}

export const Switching: React.FC<SwitchingProps> = ({
  title,
  subtitle,
  cta: { ctaUrl, ctaLabel },
  compMobileImgUrl,
  compDesktopImgUrl,
  ...sectionProps
}) => {
  return (
    <StyledSection {...sectionProps} py={[40, 70]}>
      <Title data-edit-for="title" tabIndex={0}>
        {parse(title)}
      </Title>
      <StyledSubtitle data-edit-for="subtitle" tabIndex={0}>
        {parse(subtitle)}
      </StyledSubtitle>
      <DesktopImage src={compDesktopImgUrl} alt="" width={582} />
      <MobileImage src={compMobileImgUrl} alt="" width={347} />
      <StyledLink flavor="primary" glowing customUrl={ctaUrl} data-position="bottom" data-source="switching">
        {ctaLabel}
      </StyledLink>
    </StyledSection>
  );
};
